import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    ordenTrabajo: {},
    ordenTrabajoAlternativa: {},

    rubroTrabajo: '',
    categoriaServicio: '',
    moneda: '',
    
    titulo: '',
    descripcion: '',
    cantidad: 0,
    costoEstimado: 0,
    costoEstimadoTotal: 0,
    costoUnitario: false,
    costoInterno: 0,

    /* Parametros */
    clienteId: 0,
    discriminarCategoriaServicio: false
};

const mutations = {
    updateField,

    'INICIALIZAR_ALTERNATIVA' (state) {
        state.ordenTrabajo = {};
        state.ordenTrabajoAlternativa = {};

        state.rubroTrabajo = '';
        state.categoriaServicio = '';
        state.moneda = '';
        
        state.titulo = '';
        state.descripcion = '';
        state.cantidad = 0;
        state.costoEstimado = 0;
        state.costoEstimadoTotal = 0;
        state.costoUnitario = false;

        state.readOnly = false;
        state.pjeRentabilidadOriginal = 0;
    },
    'SET_ALTERNATIVA' (state, params) {
        state.ordenTrabajo = params.ordenTrabajo;
        state.rubroTrabajo = params.ordenTrabajo.rubroTrabajo.nombre.trim();
        state.moneda = params.ordenTrabajo.moneda.nombre.trim();
        
        if (params.ordenTrabajoAlternativa) {
            state.ordenTrabajoAlternativa = params.ordenTrabajoAlternativa;
            state.titulo = params.ordenTrabajoAlternativa.titulo.trim();
            state.descripcion = params.ordenTrabajoAlternativa.descripcion.trim();
            state.cantidad = parseFloat(params.ordenTrabajoAlternativa.cantidad);
            state.costoEstimado = parseFloat(params.ordenTrabajoAlternativa.costoEstimado);
            state.costoEstimadoTotal = parseFloat(params.ordenTrabajoAlternativa.costoEstimadoTotal);
            state.costoUnitario = params.ordenTrabajoAlternativa.costoUnitario;
        }
    },
    'UPDATE_ALTERNATIVA'(state, params) {
        state.ordenTrabajoAlternativa.titulo = params.titulo.trim();
        state.ordenTrabajoAlternativa.descripcion = params.descripcion.trim();
        state.ordenTrabajoAlternativa.cantidad = params.cantidad;
        state.ordenTrabajoAlternativa.costoEstimado = params.costoEstimado;
        state.ordenTrabajoAlternativa.costoEstimadoTotal = params.costoEstimadoTotal;
        state.ordenTrabajoAlternativa.costoUnitario = params.costoUnitario;
    },
    'CALCULAR_COSTO_UNITARIO'(state) {
        if (state.cantidad != 0) {
            state.costoEstimado = helpers.methods.roundToTwo(state.costoEstimadoTotal / state.cantidad);
        } else {
            state.costoEstimado = 0;
        }
    },
    'CALCULAR_COSTO_TOTAL'(state) {
        state.costoEstimadoTotal = helpers.methods.roundToTwo(state.costoEstimado * state.cantidad);
    },
};

const getters = {
    getField,

    ordenTrabajoAlternativa (state) {
        return state.ordenTrabajoAlternativa;
    },
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ALTERNATIVA');
            
            commit('SET_ALTERNATIVA', params);
            resolve();
        })            
    },
    save ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            let params = {
                titulo: state.titulo.toUpperCase().trim(),
                descripcion: state.descripcion.trim(),
                cantidad: parseInt(state.cantidad),
                costoEstimado: parseFloat(state.costoEstimado),
                costoEstimadoTotal: parseFloat(state.costoEstimadoTotal),
                costoUnitario: (/true/i).test(state.costoUnitario),
            }
            commit('UPDATE_ALTERNATIVA', params);
            resolve()
        })
    },
    calcularCostoUnitario: ( {commit }) => {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_COSTO_UNITARIO');
            resolve();
        })
    },
    calcularCostoTotal: ( {commit }) => {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_COSTO_TOTAL');
            resolve();
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}